import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
      this.router.navigate(['/home']);
      return false;
    }

    const isAuthenticated = !!localStorage.getItem('user'); // Verifica si hay un usuario autenticado
    if (!isAuthenticated) {
      this.router.navigate(['/home']); // Redirige al login si no está autenticado
      return false; // Bloquea la navegación
    }
    return true; // Permite el acceso si está autenticado
  }

}
